let markdownItModule = null;
const loadMarkdownIt = () => {
    markdownItModule ??= import('markdown-it')
        .then((module) => module.default)
        .catch((error) => {
        markdownItModule = null;
        throw error;
    });
    return markdownItModule;
};
/** Creates a markdown-it renderer, downloading the library on first use instead of at boot. */
export const createMarkdownIt = async (options) => {
    const MarkdownItClass = await loadMarkdownIt();
    return new MarkdownItClass(options);
};
